<script>
  import AmpelBoxVersionEins from "./AmpelBoxVersionEins.svelte";
  import LineBarMixedChart from "./LineBarMixedChart.svelte";
  import { get_labels, remove_undefined, transform_month_data } from "./SixModulesUtils.svelte";
  import { dict_to_sum, nur_aktuelle_monate } from "./UtilsBalkenProgress.svelte";
  import { object_values } from "./Utils.svelte";

  export let redraw;
  export let months;
  export let months_vorjahr;
  export let year = 2090;
  export let target_cost = 10;
  export let target_revenue = 60;
  export let include_vorjahr;
  export let monthly_revenue_target = {};
  export let month_data_revenue = {
    "2022-01": 20,
    "2022-02": 3,
    "2022-03": 40,
    "2022-04": 50,
    "2022-05": 0,
    "2022-06": 75,
    "2022-07": 0,
    "2022-08": 10,
    // '2022-09': 10,
    // '2022-10': 10,
    // '2022-11': 10,
  };
  export let month_data_costs = {
    "2022-01": -200000,
    "2022-02": -2000000,
    "2022-03": -4000000,
    "2022-04": -5000000,
    "2022-05": -5500000,
    "2022-06": -5600000,
    "2022-07": -5700000,
    "2022-08": -6500000,
    // '2022-09': 1000000,
    // '2022-10': 1000000,
    // '2022-11': 1000000,
  };
  export let month_data_ebitda = {
    "2022-01": 30,
    "2022-02": 35,
    "2022-03": 35,
    "2022-04": 35,
    "2022-05": 60,
    "2022-06": 75,
    "2022-07": 80,
    "2022-08": 90,
    // '2022-09': 10,
    // '2022-10': 10,
    // '2022-11': 10,
  };

  //TODO Letzter Eintrag in Array entfernen wenn er Null ist(?)

  export let month_data_vorjahr_revenue = {
    "2022-01": 10,
    "2022-02": 3,
    "2022-03": 30,
    "2022-04": 40,
    "2022-05": 0,
    "2022-06": 65,
    "2022-07": 0,
    "2022-08": 5,
    // '2022-09': 10,
    // '2022-10': 10,
    // '2022-11': 10,
  };
  export let month_data_vorjahr_costs = {
    "2022-01": -2,
    "2022-02": -10,
    "2022-03": -30,
    "2022-04": -40,
    "2022-05": -70,
    "2022-06": -56,
    "2022-07": -57,
    "2022-08": -65,
    // '2022-09': 10,
    // '2022-10': 10,
    // '2022-11': 10,
  };
  export let month_data_vorjahr_ebitda = {
    "2022-01": 15,
    "2022-02": 23,
    "2022-03": 24,
    "2022-04": 35,
    "2022-05": 47,
    "2022-06": 66,
    "2022-07": 68,
    "2022-08": 70,
    // '2022-09': 10,
    // '2022-10': 10,
    // '2022-11': 10,
  };

  export let time_modus = "monthly";

  let data = {
    labels: ["Jan", "Feb", "Mar", "Apr"],
    datasets: [
      {
        label: "Dataset 1",
        data: [25, 35, 45, 55],
        type: time_modus == "biannual" ? "bar" : "line",
        borderColor: "#4eb3cf",
        pointRadius: 0,
      },
      {
        label: "Dataset 2",
        data: [20, 30, 35, 50],
        type: time_modus == "biannual" ? "bar" : "line",
        borderColor: "#afcb08",
        pointRadius: 0,
      },
      {
        label: "Dataset 3",
        data: [20, 30, 35, 50],
        type: "bar",
        borderColor: "#afcb08",
        pointRadius: 0,
      },
      {
        label: "Dataset 4",
        data: [15, 20, 30, 45],
        type: "bar",
        borderColor: "#d9d9d9",
        pointRadius: 0,
      },
    ],
  };

  $: {
    target_cost,
      target_revenue,
      month_data_revenue,
      month_data_costs,
      month_data_ebitda,
      month_data_vorjahr_revenue,
      month_data_vorjahr_costs,
      month_data_vorjahr_ebitda,
      time_modus,
      include_vorjahr;

    if (
      month_data_revenue &&
      month_data_costs &&
      month_data_ebitda &&
      month_data_vorjahr_revenue &&
      month_data_vorjahr_costs &&
      month_data_vorjahr_ebitda &&
      time_modus
    ) {
      // console.log('months: ', months);
      // console.log('month_data_revenue: ', month_data_revenue);
      console.log("month_data_costs in mgmrevenuecostebitda: ", month_data_costs);
      console.log("object_values(month_data_costs): ", object_values(month_data_costs));

      month_data_ebitda = {};
      months.forEach((m) => {
        month_data_ebitda[m] = month_data_revenue[m] + (m in month_data_costs ? month_data_costs[m] : 0);

        // // console.log("REchnung: ", month_data_revenue[m])
        // // console.log("-")
        // // console.log(month_data_costs[m])
        // // console.log(" => ")
        // // console.log(month_data_ebitda[m])
        // // console.log(month_data_revenue[m] + month_data_costs[m])
        // // console.log("====")
      });
      month_data_vorjahr_ebitda = {};
      months_vorjahr.forEach((m) => {
        month_data_vorjahr_ebitda[m] = month_data_vorjahr_revenue[m] + (m in month_data_vorjahr_costs ? month_data_vorjahr_costs[m] : 0);
      });

      // console.log('month_data_ebitda: ', month_data_ebitda);
      // console.log("dict_to_sum_prüfen: ", dict_to_sum(month_data_costs))
      // console.log("target_cost: ", target_cost)
      // console.log("dict_to_sum_prüfen: ", dict_to_sum(target_cost))
      // console.log("n formatter: ", nFormatter_org(dict_to_sum(target_cost)))

      console.log("###: ", object_values(month_data_costs));

      data = {
        labels: get_labels(year, time_modus),
        datasets: [
          include_vorjahr
            ? {
                label: "Revenue Previous year",
                data: transform_month_data(object_values(month_data_vorjahr_revenue), time_modus),
                type: time_modus == "biannual" ? "bar" : "line",
                // borderColor: '#455f51',
                borderColor: time_modus == "biannual" ? "#D9D9D9" : "#bfbfbf",
                pointRadius: 0,
                // borderDash: [3, 3],
              }
            : {},
          {
            label: "Revenue",
            data: transform_month_data(object_values(month_data_revenue), time_modus, "revenue"),
            type: time_modus == "biannual" ? "bar" : "line",
            borderColor: "#455f51",
            pointRadius: 0,
          },
          include_vorjahr
            ? {
                label: "Costs Previous year",
                data: transform_month_data(object_values(month_data_vorjahr_costs), time_modus),
                type: time_modus == "biannual" ? "bar" : "line",
                borderColor: time_modus == "biannual" ? "#D9D9D9" : "#BFBFBF",
                pointRadius: 0,
                borderDash: [3, 3],
              }
            : {},
          {
            label: "Costs",
            data: transform_month_data(object_values(month_data_costs), time_modus, "cost"),
            type: time_modus == "biannual" ? "bar" : "line",
            // borderColor: '#bfbfbf',
            borderColor: time_modus == "biannual" ? "#FFFFFF" : "#455F51",
            rahmen_farbe: time_modus == "biannual" ? "#455F51" : false,
            pointRadius: 0,
            borderDash: [3, 3],
          },
          include_vorjahr
            ? {
                label: "EBITDA Previous year",
                data: transform_month_data(object_values(month_data_vorjahr_ebitda), time_modus),
                type: time_modus == "biannual" ? "bar" : "line",
                borderColor: time_modus == "biannual" ? "#D9D9D9" : "rgba(0, 112, 192, 0.24)",
                pointRadius: 0,
              }
            : {},
          {
            label: "EBITDA",
            data: transform_month_data(object_values(month_data_ebitda), time_modus),
            type: time_modus == "biannual" ? "bar" : "line",
            borderColor: time_modus == "biannual" ? "#D7E2DC" : "#0070C0",
            rahmen_farbe: time_modus == "biannual" ? "#455F51" : false,
            pointRadius: 0,
          },
        ],
      };

      redraw = false;
      redraw = true;
    }
  }
</script>

<div class="row">
  <div class="col" style="padding-right: 0px;">
    <AmpelBoxVersionEins
      target={nur_aktuelle_monate(year, months, monthly_revenue_target)}
      current_target={nur_aktuelle_monate(year, months, monthly_revenue_target)}
      current={dict_to_sum(remove_undefined(month_data_revenue))}
      unterer_text={"Revenue " + (year == new Date().getFullYear() ? "" + "YTD" : (year - 2000).toString())}
      circle_size={20}
      replace_current={dict_to_sum(remove_undefined(month_data_revenue))}
      ampel_ganz_links={true}
      image={time_modus == "biannual" ? "1_ HY Revenue_stack.png" : "1_Monthly revenue.png"}
      image_height={time_modus == "biannual" ? 8 : 2}
    />
  </div>
  <div class="col">
    <AmpelBoxVersionEins
      target={nur_aktuelle_monate(year, months, target_cost)}
      current_target={nur_aktuelle_monate(year, months, target_cost)}
      current={dict_to_sum(remove_undefined(month_data_costs))}
      unterer_text={"Costs " + (year == new Date().getFullYear() ? "" + "YTD" : (year - 2000).toString())}
      circle_size={20}
      replace_current={dict_to_sum(remove_undefined(month_data_costs))}
      ampel_ganz_links={true}
      image={time_modus == "biannual" ? "2_HY Costs_stack.png" : "2_Monthly costs.png"}
      image_height={time_modus == "biannual" ? 8 : 2}
    />
  </div>
  <div class="col" style="padding-left: 0px;">
    <AmpelBoxVersionEins
      target={nur_aktuelle_monate(year, months, monthly_revenue_target) + nur_aktuelle_monate(year, months, target_cost)}
      current_target={nur_aktuelle_monate(year, months, monthly_revenue_target) + nur_aktuelle_monate(year, months, target_cost)}
      current={dict_to_sum(remove_undefined(month_data_revenue)) + dict_to_sum(remove_undefined(month_data_costs))}
      unterer_text={"EBITDA " + (year == new Date().getFullYear() ? "" + year.toString() + "YTD" : (year - 2000).toString())}
      circle_size={20}
      replace_current={dict_to_sum(remove_undefined(month_data_revenue)) + dict_to_sum(remove_undefined(month_data_costs))}
      ampel_ganz_links={true}
      image={time_modus == "biannual" ? "3_HY EBITDA I_stack.png" : "3_Monthly EBITDA I.png"}
      image_height={time_modus == "biannual" ? 8 : 2}
    />
  </div>
</div>

<div class="row" style="width:100%; margin: 0px;">
  <div class="col" style="margin:0px; padding:0px; height:0px;">
    <LineBarMixedChart
      id={Math.floor(Math.random() * 1000000)}
      line_data={data}
      barPercentage={0.9}
      categoryPercentage={0.7}
      type={"bar"}
      bind:redraw
      k={true}
      m={true}
      ohne_nachkomma={true}
    />
  </div>
</div>

<style>
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .rotate {
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    transform: rotate(-90deg);
  }
</style>
